import TomSelect from 'tom-select';
import bwipjs from 'bwip-js';
import { createCooldownWithLock } from '@/js/autorization/timer.utils';

export default class Certificate {
	constructor() {
		this.init();
	}

	init() {
		const globalCertificateData = window.globalCertificateData;
		if (!globalCertificateData) return;
		this.certificateData = window.globalConf(globalCertificateData);
		this._checkAuth();

		this.certificateContainer = document.querySelector('#category-certificate-wrapper');
		this.productsContainer = document.querySelector('#account-products-xp');
		this.productsXpTitle = document.querySelector('.catalog__xp-group-heading');
		this.certificateTitle = document.querySelector('.catalog__xp-group-heading');
		this.productsCatalogContainer = document.querySelector('#Collection');
		this.partnerContainer = document.querySelector('#partner-wrapper');
		this.certificateActiveContainer = document.querySelector('#active-certificate-wrapper');


		this.certificateTemplate = document.querySelector('[data-template="active-partner"]')?.innerHTML || '';
		this.certificatePartnerTemplate = document.querySelector('[data-template="partner-card"]')?.innerHTML || '';
		this.certificateCategoryTemplate = document.querySelector('[data-template="category-template"]')?.innerHTML || '';
		this.createPinBtn = document.querySelector('[data-template="create-pin"]')?.innerHTML || '';
		this.createPinBtnTxt = document.querySelector('[data-template="create-pin-txt"]')?.innerHTML || '';

		this.accountInfoTab = document.querySelector('.club-tab-content.with-certificate');
		this.filterWrapper = document.querySelector('.filter__category.certificates-filter');
		this.xpProductsFilter = document.querySelector('.filter__category.xp-products-filter');
		this.certBtnWrappper = document.querySelector('.sertitficate-btn-wrapper');
		this.catalogTitle = document.querySelector('[data-id="seo-title-catalog"]');
		this.catalogSeoText = document.querySelector('.footer-description');
		this.catalog = document.querySelector('.catalog');

		this.pinInstallForm = document.querySelectorAll('#certificate_pin');
		this.pinRecoveryForm = document.querySelector('#pop_pin_recovery');
		this.pinSendSms = document.querySelector('#certificate_sms');

		this.createPinBtn = document.querySelector('.js-create-pin');
		this.setedPinBlock = document.querySelector('.catalog__xp-pin-set');

		this.timerEl = document.querySelector('#sms-timer');
		this.resendBtn = document.querySelector('.js-sms-resend');

		this.cooldown = null;

		this.certificateMinLimit = 0;
		this.isVerified = window.CertificateCustomerData?.isVerified;

		this.pinInstallForm?.forEach((form)=>{
			form.addEventListener('submit', e => this._installPin(e));
		});
		this.pinRecoveryForm?.addEventListener('submit', e => this._installPin(e));
		this.pinSendSms?.addEventListener('submit', e => this._sendSms(e));
		this._initPartnerInfoAccessibility();
		this._initCatalogXpFilters();
		this._btnEvents();
	}

	_initPartnerInfoAccessibility() {
		document.querySelectorAll('.partner-card').forEach((card, index) => {
			const button = card.querySelector('.partner-card__info-btn');
			const info = card.querySelector('.partner-card__info');
			const infoWrapper = card.querySelector('.partner-card__info--wrapper');

			if (!button || !info) return;

			if (!info.id) info.id = `partner-card-info-${index + 1}`;

			infoWrapper?.setAttribute('tabindex', '0');
			button.setAttribute('aria-controls', info.id);
			button.setAttribute('aria-expanded', info.style.display === 'block' ? 'true' : 'false');
		});
	}

	_closePartnerInfo(info, returnFocus = false) {
		if (!info) return;

		info.style.display = 'none';
		const button = document.querySelector(`.partner-card__info-btn[aria-controls="${info.id}"]`);
		button?.setAttribute('aria-expanded', 'false');
		if (returnFocus) button?.focus();
	}

	_closeAllPartnerInfo() {
		document.querySelectorAll('.partner-card__info').forEach(info => this._closePartnerInfo(info));
	}

	_openPartnerInfo(button) {
		const info = button.nextElementSibling;
		if (!info || !info.classList.contains('partner-card__info')) return;

		this._closeAllPartnerInfo();
		info.style.display = 'block';
		button.setAttribute('aria-expanded', 'true');
	}

	_handlePartnerInfoKeydown = (event) => {
		if (event.key !== 'Escape') return;

		const openInfo = document.querySelector('.partner-card__info[style*="display: block"]');
		if (!openInfo) return;

		event.preventDefault();
		this._closePartnerInfo(openInfo, true);
	};

	_getFocusableElements(container) {
		const focusableSelectors = [
			'a[href]',
			'button:not([disabled])',
			'input:not([disabled])',
			'select:not([disabled])',
			'textarea:not([disabled])',
			'[tabindex]:not([tabindex="-1"])'
		].join(',');

		return [...container.querySelectorAll(focusableSelectors)]
			.filter(element => element.offsetParent !== null);
	}

	_focusCertificatePopup(popup, preferredSelector) {
		if (!popup) return;

		if (!popup.hasAttribute('tabindex')) {
			popup.setAttribute('tabindex', '-1');
		}

		const preferredElement = preferredSelector ? popup.querySelector(preferredSelector) : null;
		const focusableElements = this._getFocusableElements(popup);
		const target = preferredElement || focusableElements[0] || popup;

		requestAnimationFrame(() => target.focus({ preventScroll: true }));
	}

	_openCertificatePopup(selector, preferredSelector) {
		const popup = document.querySelector(selector);
		if (!popup) return;

		popup.style.display = 'block';
		this._focusCertificatePopup(popup, preferredSelector);
	}

	_focusInput(input) {
		requestAnimationFrame(() => input?.focus({ preventScroll: true }));
	}

	_getInputErrorElement(input) {
		const errorId = input?.getAttribute('aria-errormessage') || (input?.id ? `${input.id}-error` : '');
		return errorId ? document.getElementById(errorId) : input?.closest('.input')?.querySelector('.error');
	}

	_setInputError(input, message) {
		if (!input) return;

		const errorElement = this._getInputErrorElement(input);
		if (input.id && !input.hasAttribute('aria-errormessage')) {
			input.setAttribute('aria-errormessage', `${input.id}-error`);
		}

		input.setAttribute('aria-invalid', 'true');
		input.closest('.input')?.classList.add('input--error');

		if (errorElement) {
			errorElement.textContent = message;
			errorElement.setAttribute('role', 'alert');
			errorElement.setAttribute('aria-live', 'assertive');
		}
	}

	_clearInputError(input) {
		if (!input) return;

		input.removeAttribute('aria-invalid');
		input.closest('.input')?.classList.remove('input--error');

		const errorElement = this._getInputErrorElement(input);
		if (errorElement) errorElement.textContent = '';
	}

	_showCertificateResult(block, isError = false) {
		if (!block) return;

		block.style.display = 'block';
		block.setAttribute('tabindex', '-1');
		block.setAttribute('role', isError ? 'alert' : 'status');
		block.setAttribute('aria-live', isError ? 'assertive' : 'polite');
		block.setAttribute('aria-atomic', 'true');

		requestAnimationFrame(() => block.focus({ preventScroll: true }));
	}

	_handleCertificatePopupKeydown = (event) => {
		if (event.key !== 'Tab') return;

		const popup = event.target.closest('.certificate-popup-overlay .pop-item');
		if (!popup || popup.style.display !== 'block') return;

		const focusableElements = this._getFocusableElements(popup);
		if (!focusableElements.length) {
			event.preventDefault();
			popup.focus({ preventScroll: true });
			return;
		}

		const firstElement = focusableElements[0];
		const lastElement = focusableElements[focusableElements.length - 1];

		if (event.shiftKey && document.activeElement === firstElement) {
			event.preventDefault();
			lastElement.focus({ preventScroll: true });
		}

		if (!event.shiftKey && document.activeElement === lastElement) {
			event.preventDefault();
			firstElement.focus({ preventScroll: true });
		}
	};

	_checkAuth() {
		const url = this.certificateData.apiDomain + this.certificateData.methods.auth;

		fetch(url, {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
			body: JSON.stringify(this.certificateData.authBody)
		})
			.then(r => r.ok ? r.json() : Promise.reject())
			.then(data => {
				if (!data) return;
				this.token = data.token;

				this._registerCustomer();

				if (this.isVerified) {
					this._renderPartners();
				} else {
					this._getPartnersCategories();
				}

				this._getMinLimit();
			})
			.catch(() => console.log("Can't authorized"));
	}

	_registerCustomer() {
		const url = this.certificateData.apiDomain + this.certificateData.methods.customerRegister;

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': this._getToken()
			},
			body: JSON.stringify({
				phone: window.CertificateCustomerData.phone,
				first_name: window.CertificateCustomerData.first_name,
				second_name: window.CertificateCustomerData.last_name,
				email: window.CertificateCustomerData.email
			})
		}).catch(() => console.log("Can't register"));
	}

	_getMinLimit() {
		const url = `${this.certificateData.apiDomain}${this.certificateData.methods.getSettings}?phone=${window.CertificateCustomerData.phone}`;

		fetch(url, {
			headers: { Authorization: this._getToken() }
		})
			.then(r => r.json())
			.then(res => {
				if (!res?.data) return;

				if (res.data.certificate_min !== null) {
					this.certificateMinLimit = res.data.certificate_min;
				}

				if (res.data.customerHasPinCode) {

					this.createPinBtn.remove();
					this.setedPinBlock.hidden = false;
					this.setedPinBlock.style.display = 'flex';

					if (location.href.includes('a/products')) {
						this.certBtnWrappper?.insertAdjacentHTML('afterbegin', this.createPinBtnTxt);
						this.catalog?.classList.add('catalog--pin-set');
					}
				} else {
					if (location.href.includes('a/products')) {
						this.certBtnWrappper?.insertAdjacentHTML('afterbegin', this.createPinBtn);
					}
				}
			});
	}

	_getPartnersCategories() {
		if (this.certificateContainer) {
			this.certificateContainer.classList.add('loading');
			this.certificateContainer.style.display = 'block';
		}
		this._getMessage('main');

		const url = this.certificateData.apiDomain +
			this.certificateData.methods.getPartnersCategories +
			window.CertificateCustomerData.phone;

		fetch(url, { headers: { Authorization: this._getToken() } })
			.then(r => r.json())
			.then(data => {
				const wrapper = this.certificateContainer.querySelector('.category-certificate-wrapper');
				wrapper.innerHTML = '';

				data.forEach(cat => {
					const card = this._createCategoryCard(cat);
					wrapper.appendChild(card);
				});

				this.certificateContainer.classList.remove('loading');
				this._clickCategory();
			});
	}

	_createCategoryCard(cat) {
		const tpl = document.createElement('div');
		tpl.innerHTML = this.certificateCategoryTemplate;
		const card = tpl.firstElementChild;

		card.dataset.categoryId = cat.CATEGORY_ID;
		card.dataset.categoryName = cat.CATEGORY_NAME;
		card.querySelector('.points_card-new')?.remove();
		const img = card.querySelector('img');
		if (img) {
			const baseUrl = this.certificateData.assetsUrl.split('?')[0];
			img.src = `${baseUrl}category-${cat.CATEGORY_ID}.webp`;
		}
		const title = card.querySelector('[data-category-name]');
		if (title) title.textContent = cat.CATEGORY_NAME;

		return card;
	}

	_renderPartners() {
		if (this.certificateContainer) {
			this.certificateContainer.classList.add('loading');
			this.certificateContainer.style.display = 'block';
		}

		const url = this.certificateData.apiDomain +
			this.certificateData.methods.getPartners +
			window.CertificateCustomerData.phone;

		fetch(url, { headers: { Authorization: this._getToken() } })
			.then(r => r.json())
			.then(data => {
				const wrapper = this.certificateContainer.querySelector('.category-certificate-wrapper');
				wrapper.innerHTML = '';
				const categoriesMap = new Map();

				data.forEach(partner => {
					const item = this._createPartnerCard(partner);
					wrapper.appendChild(item);

					if (partner.CATEGORIES) {
						partner.CATEGORIES.forEach(c => {
							if (!categoriesMap.has(c.CATEGORY_ID)) {
								categoriesMap.set(c.CATEGORY_ID, c.CATEGORY_NAME);
							}
						});
					}

				});

				const categories = Array.from(categoriesMap, ([id, name]) => ({id, name}));
				this._renderFilter(categories);

				this.certificateContainer.classList.remove('loading');
			});
	}

	_renderFilter(categories) {
		const template = document.querySelector('script[data-template="certificate-filter"]');
		if (!template) return;

		const container = document.getElementById('certificates-filter-items');
		if (!container) return;

		container.innerHTML = '';

		const allCategories = [{ id: 'all', name: 'Усі сертифікати' }, ...categories];

		allCategories.forEach((cat, index) => {
			const tplWrapper = document.createElement('div');
			tplWrapper.innerHTML = template.innerHTML.trim();
			const item = tplWrapper.firstElementChild;

			const checkbox = item.querySelector('input[type="checkbox"]');
			if (checkbox) {
				checkbox.name = 'category';
				checkbox.value = cat.id;
				checkbox.setAttribute('aria-describedby', `category-${cat.id}`);
				if (index === 0) {
					checkbox.checked = true;
					item.classList.add('is-active-filter');
				}
			}

			const nameEl = item.querySelector('.filter__item-name');
			if (nameEl) {
				nameEl.dataset.name = `category-${cat.id}`;
				nameEl.dataset.value = cat.id;
				nameEl.textContent = cat.name;
			}

			container.appendChild(item);
		});

		if (allCategories.length > 1) {
			this.filterWrapper.style.display = 'block';
		}

		this._filterTrigger();
	}

	_filterTrigger() {
		const filterItems = document.querySelectorAll('#certificates-filter-items input[name="category"]');
		const partnerCards = document.querySelectorAll('.partner-card');

		filterItems.forEach(input => {
			input.addEventListener('change', (e) => {
				const currentInput = e.target;
				const isAll = currentInput.value === 'all';

				if (isAll) {
					if (currentInput.checked) {
						filterItems.forEach(item => {
							if (item !== currentInput) {
								item.checked = false;
								item.closest('.filter__item')?.classList.remove('is-active-filter');
							}
						});
					} else {
						currentInput.checked = true;
					}
				} else {
					const allInput = Array.from(filterItems).find(i => i.value === 'all');
					if (currentInput.checked) {
						if (allInput) {
							allInput.checked = false;
							allInput.closest('.filter__item')?.classList.remove('is-active-filter');
						}
					}
				}

				filterItems.forEach(item => {
					if (item.checked) {
						item.closest('.filter__item')?.classList.add('is-active-filter');
					} else {
						item.closest('.filter__item')?.classList.remove('is-active-filter');
					}
				});

				const selectedCategories = Array.from(filterItems)
					.filter(i => i.checked)
					.map(i => i.value);

				if (selectedCategories.length === 0) {
					const allInput = Array.from(filterItems).find(i => i.value === 'all');
					if (allInput) {
						allInput.checked = true;
						allInput.closest('.filter__item')?.classList.add('is-active-filter');
						selectedCategories.push('all');
					}
				}

				partnerCards.forEach(card => {
					if (selectedCategories.includes('all')) {
						card.style.display = 'block';
					} else {
						const cardCategoryId = card.dataset.categoryId;
						if (selectedCategories.includes(cardCategoryId)) {
							card.style.display = 'block';
						} else {
							card.style.display = 'none';
						}
					}
				});
			});
		});
	}

	_clickCategory() {
		document.addEventListener('click', e => {
			const btn = e.target.closest('.category-partners-js');
			if (!btn) return;

			e.preventDefault();

			const categoryId = btn.dataset.categoryId;
			const categoryName = btn.dataset.categoryName;

			let url = this.certificateData.apiDomain +
				this.certificateData.methods.getPartners +
				window.CertificateCustomerData.phone;

			if (categoryId !== 'all') {
				url += `?categoryId=${categoryId}`;
			}

			this._getMessage(categoryId);

			fetch(url, { headers: { Authorization: this._getToken() } })
				.then(r => r.json())
				.then(data => {
					const wrapper = this.partnerContainer.querySelector('.partner-wrapper');
					wrapper.innerHTML = '';

					data.forEach(partner => {
						const item = this._createPartnerCard(partner, categoryId);
						wrapper.appendChild(item);
					});
					this._initPartnerInfoAccessibility();

					const partnerTitle = this.partnerContainer.querySelector('.partner-title');
					if (partnerTitle) partnerTitle.textContent = categoryName;
					if (this.certificateContainer) this.certificateContainer.style.display = 'none';
					this.partnerContainer.style.display = 'block';

					const top = this.partnerContainer.offsetTop - 320;
					window.scrollTo({ top: top, behavior: 'smooth' });
				});
		});
	}

	_createPartnerCard(partner, categoryId = null) {
		const tpl = document.createElement('div');
		tpl.innerHTML = this.certificatePartnerTemplate;
		const item = tpl.firstElementChild;
		const partnerName = partner.PARTNER_NAME || partner.NAME || '';

		if (partnerName) {
			item.setAttribute('tabindex', '0');
			item.setAttribute('aria-label', `Сертифікат можна використати в ${partnerName}`);
		}

		const infoButton = item.querySelector('.partner-card__info-btn');
		if (infoButton && partnerName) {
			infoButton.setAttribute('aria-label', `Переглянути додаткову інформацію про сертифікат ${partnerName}`);
		}

		const infoWrapper = item.querySelector('.partner-card__info--wrapper');
		if (infoWrapper) {
			infoWrapper.innerHTML = partner.RULES || '';
			infoWrapper.insertAdjacentHTML('afterbegin', `<button type="button" class="close" aria-label="Закрити"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.292969 1.70691C-0.0974039 1.31639 -0.0974703 0.683328 0.292969 0.292847C0.683448 -0.0976181 1.3165 -0.0975342 1.70703 0.292847L6.60254 5.18835L11.4912 0.304565C11.8819 -0.0856838 12.5159 -0.0850554 12.9062 0.305542C13.2962 0.696251 13.2958 1.32937 12.9053 1.7196L8.0166 6.60242L12.9053 11.4911C13.2958 11.8816 13.2958 12.5146 12.9053 12.9052C12.5147 13.2956 11.8817 13.2957 11.4912 12.9052L6.60059 8.01648L1.70703 12.9052C1.31642 13.2953 0.683309 13.2955 0.292969 12.9052C-0.0970713 12.5145 -0.0973346 11.8814 0.292969 11.4911L5.18652 6.60242L0.292969 1.70691Z" fill="#6F7171"/></svg></button>`);
		}

		const logo = item.querySelector('.partner-card__logo img');
		if (logo) {
			logo.src = partner.BIG_LOGO;
			logo.alt = partnerName;
		}

		const form = item.querySelector('form');
		if (form) {
			form.dataset.partnerId = partner.PARTNER_ID;
			form.setAttribute('aria-label', partnerName ? `Замовлення сертифіката ${partnerName}` : 'Замовлення сертифіката');
			if (partner.MOBILE_OPERATOR === 1) {
				form.dataset.mobileOperator = 'true';
				item.querySelector('.partner-card__form-success:not(.mobile-operator)')?.remove();
				item.querySelector('.partner-card__form-loading:not(.mobile-operator)')?.remove();
				item.classList.add('wrapper-mobile-operator');
			} else {
				item.querySelector('.partner-card__form-success.mobile-operator')?.remove();
				item.querySelector('.partner-card__form-loading.mobile-operator')?.remove();
			}
		}

		const categoryInclude = item.querySelector('.category-include');
		if (categoryInclude && partner.CATEGORIES && partner.CATEGORIES.length > 0) {
			const idNum = categoryId !== null ? parseInt(categoryId) : NaN;
			const selectedCategory = !isNaN(idNum) ? partner.CATEGORIES.find(c => c.CATEGORY_ID === idNum) : null;
			categoryInclude.textContent = selectedCategory ? selectedCategory.CATEGORY_NAME : partner.CATEGORIES[0].CATEGORY_NAME;
			item.dataset.categoryId = selectedCategory ? selectedCategory.CATEGORY_ID : partner.CATEGORIES[0].CATEGORY_ID;
		}

		const limitsBlock = item.querySelector('.limits_nominal');

		if (partner.DISCRETE === 1) {
			const nominals = partner.NOMINAL || [];
			const nominalLimits = partner.NOMINAL_LIMITS || {};
			const isSoldOut = (nominals.length === 0 || Object.values(nominalLimits).every(l => l === 0) || nominals.every(n => nominalLimits[n] === 0)) && partner.MOBILE_OPERATOR !== 1;

			if (isSoldOut) {
				form?.remove();
				limitsBlock?.insertAdjacentHTML('beforeend', `
					<div class="limit-value sould">
						0 шт
						<span class="tooltip">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
								<g clip-path="url(#clip0_24728_3549)">
									<path d="M6.05992 6C6.21665 5.55445 6.52602 5.17874 6.93322 4.93942C7.34042 4.70011 7.81918 4.61263 8.2847 4.69248C8.75022 4.77233 9.17246 5.01435 9.47664 5.37569C9.78081 5.73702 9.94729 6.19435 9.94659 6.66667C9.94659 8 7.94659 8.66667 7.94659 8.66667M7.99992 11.3333H8.00659M14.6666 8C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8C1.33325 4.3181 4.31802 1.33334 7.99992 1.33334C11.6818 1.33334 14.6666 4.3181 14.6666 8Z" stroke="#C52325" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
								</g>
								<defs><clipPath id="clip0_24728_3549"><rect width="16" height="16" fill="white"/></clipPath></defs>
							</svg>
						</span>
					</div>
				`);
				item.querySelector('.partner-card__form')?.insertAdjacentHTML('beforeend', '<div class="partner-false" style="z-index: 2;"><p><strong>Даний сертифікат закінчився</strong><p>На жаль, даний сертифікат закінчився. Будь ласка, вибери інший номінал із доступних сертифікатів.</p></div>');
			} else {
				item.querySelector('.input-group')?.remove();
				const select = item.querySelector('select');
				if (nominals.length === 1) {
					const firstNominal = nominals[0];
					const formGroup = item.querySelector('.form-group');
					if (formGroup) {
						formGroup.innerHTML = `
							<div class="input">
								<div class="input__wrapper">
									<input type="text" class="input__el" placeholder="Введіть суму" value="${firstNominal}" name="amount" min="1" max="400" pattern="[0-9]+" readonly disabled>
								</div>
							</div>`;
					}
				}

				const sortedNominals = [...nominals].sort((a, b) => a - b);
				let checkVariant = true;

				sortedNominals.forEach(nominal => {
					const limit = nominalLimits[nominal] || 0;
					if (limit !== 0) {
						const nominalDetails = partner.NOMINAL_DETAILS?.[nominal] ? `<small style="color: #12121280;font-size: 12px;">(${partner.NOMINAL_DETAILS[nominal]})</small>` : '';
						const option = document.createElement('option');
						option.value = nominal;
						option.innerHTML = `${nominal} грн ${nominalDetails}`;
						if (checkVariant) {
							option.selected = true;
							checkVariant = false;
						}
						select?.appendChild(option);
					}

					limitsBlock?.insertAdjacentHTML('beforeend', `
						<div class="limit-value" data-nominal="${nominal}" data-limit="${limit}">
							${limit} шт
						</div>
					`);
				});

				if (select) {
					console.log(select, 'select');
					const labelText =
						select.getAttribute('aria-label') ||
						select.closest('.select')?.getAttribute('data-select-label') ||
						'Оберіть значення';
					const selectLabelText = partnerName ? `${labelText} сертифіката ${partnerName}` : labelText;
					const ts = new TomSelect(select, {
						create: false,
						controlInput: null,
						searchField: [],
						allowEmptyOption: false,
						onInitialize() {
							const control = this.control;
							const dropdown = this.dropdown_content || this.dropdown;

							select.setAttribute('aria-label', selectLabelText);

							if (control) {
								control.setAttribute('aria-label', selectLabelText);
							}

							if (dropdown) {
								dropdown.setAttribute('aria-label', selectLabelText);
							}
						}
					});

					const handleSelectChange = (val) => {
						if (partner.MOBILE_OPERATOR === 1) {
							const limitsNominal = item.querySelector('.limits_nominal');
							if (limitsNominal) limitsNominal.style.opacity = '0';
						}
						const limitValues = item.querySelectorAll('.limit-value');
						limitValues.forEach(lv => {
							lv.classList.remove('active');
							lv.style.display = 'none';
							if (partner.MOBILE_OPERATOR === 0 && lv.dataset.nominal === val) {
								lv.style.display = 'block';
								lv.classList.add('active');
							}
						});

						this._changeSelect(item);
					};

					ts.on('change', handleSelectChange);
					handleSelectChange(ts.getValue());
				}
				item.querySelector('.limit-value')?.insertAdjacentHTML('beforeend', '<div class="partner-false" style="z-index: 2;"><p><strong>Даний сертифікат закінчився</strong><p>На жаль, даний сертифікат закінчився. Будь ласка, вибери інший номінал із доступних сертифікатів.</p></div>');
			}
		} else {
			item.querySelector('.select')?.remove();
			if (this.certificateMinLimit > 0) {
				limitsBlock?.insertAdjacentHTML('beforeend', `
					<div class="limit-value" data-amount-limit="${partner.AMOUNT_LIMIT}" data-spent="0">
						${partner.AMOUNT_LIMIT} грн
					</div>
				`);
				const input = item.querySelector('input');
				if (input) {
					input.max = partner.AMOUNT_LIMIT;
					input.addEventListener('input', () => {
						let val = parseInt(input.value, 10);
						const max = parseInt(input.max, 10);
						if (val > max) {
							input.value = max;
							val = max;
						}
						const lv = item.querySelector('.limit-value');
						if (lv) lv.dataset.spent = val || 0;
					});
				}
			}
		}

		const sendButton = item.querySelector('.partner-card__form-send');
		if (sendButton && partnerName) {
			sendButton.setAttribute('aria-label', `Замовити сертифікат ${partnerName}`);
		}

		return item;
	}

	_changeSelect(item) {
		const activeLimit = item.querySelector('.limit-value.active');
		const btn = item.querySelector('.partner-card__form-send');
		if (activeLimit?.dataset.limit === '0') {
			btn?.classList.add('disabled');
			btn && (btn.disabled = true);
		} else {
			btn?.classList.remove('disabled');
			btn && (btn.disabled = false);
		}
	}

	_getActiveCertificate() {
		const url = this.certificateData.apiDomain +
			this.certificateData.methods.getPartners +
			window.CertificateCustomerData.phone;

		fetch(url, { headers: { Authorization: this._getToken() } })
			.then(r => r.json())
			.then(data => {
				const container = this.certificateActiveContainer.querySelector('.active-certificate-wrapper__cards');
				container.innerHTML = '';

				data.forEach(partner => {
					partner.PARTNER_BAR_CODES?.forEach(cert => {
						if (cert.CERT_STATUS === 0 && cert.BALANCE !== 0 && cert.BAR_CODE && cert.BAR_CODE.length !== 0) {
							const item = this._createActiveCertCard(partner, cert);
							container.appendChild(item);
						}
					});
				});

				if (container.querySelectorAll('.active-partner-card').length === 0) {
					container.innerHTML = '<span class="empty-active-sertificate orange">У вас ще немає активних сертифікатів</span>';
				}

				this._toggleActiveCertView(true);
			});
	}

	_createActiveCertCard(partner, cert) {
		const tpl = document.createElement('div');
		tpl.innerHTML = this.certificateTemplate;
		const item = tpl.firstElementChild;

		if (cert.DATE_ACCEPT) {
			const parts = cert.DATE_ACCEPT.split(' ');
			const partsData = parts[0].split('.');
			const newDateFormat = `${partsData[2].trim()}.${partsData[1].trim()}.20${partsData[0].trim()} ${parts[1]}`;
			item.querySelector('.date-buy').textContent = `Придбано ${newDateFormat}`;
		}

		if (cert.PASS) {
			item.insertAdjacentHTML(
				'beforeend',
				`<div class="date-buy">pin: ${cert.PASS}</div>`
			);
		}

		const logo = item.querySelector('img.partner-logo');
		const partnerName = partner.NAME || partner.PARTNER_NAME || '';
		if (partnerName) {
			item.setAttribute('aria-label', `Сертифікат можна використати в ${partnerName}`);
		}

		if (logo) {
			logo.src = partner.BIG_LOGO;
			logo.alt = partnerName;
		}
		const balance = item.querySelector('.balance-partner');
		if (balance) balance.textContent = `${cert.BALANCE} грн`;

		let type = cert.BAR_CODE_TYPE.toLowerCase();
		if (type === 'ean_13') type = 'ean13';
		else if (type === 'data_matrix') type = 'datamatrix';

		try {
			const c = document.createElement("canvas");
			let parametr = null;
			if (partner?.PARTNER_ID === 15) {
				parametr = {
					bcid: 'databarexpandedstacked',
					text: cert.BAR_CODE,
					scaleX: 2,
					scaleY: 1,
					segments: 8,
					height: 16,
					includetext: true,
					textxalign: 'center'
				}
			} else {
					parametr = {
					bcid: type,
					text: cert.BAR_CODE,
					height: 16,
					includetext: true,
					textxalign: 'center',
				}
			}
			const canvas = bwipjs.toCanvas(c, parametr);
			const div = item.querySelector('.code-partner');
			const barcodeImage = div.querySelector('img');
			if (barcodeImage) {
				barcodeImage.src = canvas.toDataURL("image/png");
				barcodeImage.alt = partnerName
					? `Штрихкод сертифіката для використання в ${partnerName}`
					: 'Штрихкод сертифіката';
			}
			if (partner?.PARTNER_ID === 15) {
				div.insertAdjacentHTML(
					'beforeend',
					`<span>${cert.BAR_CODE}</span>`
				);
			}
		} catch (e) {
			console.error("Barcode generation failed", e);
		}

		if (type === 'qrcode' || type === 'datamatrix') {
			item.querySelector('.code-partner').insertAdjacentHTML('beforeend', `<span>${cert.BAR_CODE}</span>`);
		}

		return item;
	}

	_toggleActiveCertView(showActive) {
		const state = showActive ? 'none' : 'grid';
		const activeState = showActive ? 'grid' : 'none';

		[this.certificateContainer, this.productsContainer, this.productsXpTitle,
			this.productsCatalogContainer, this.accountInfoTab,
			this.catalogSeoText, this.certBtnWrappper, this.filterWrapper, this.xpProductsFilter, this.certificateTitle]
			.forEach(el => el && (el.style.display = state));

		if (this.partnerContainer) this.partnerContainer.style.display = 'none';

		if (this.catalogTitle) {
			this.catalogTitle.classList.toggle('show', !showActive);
			this.catalogTitle.classList.toggle('hide', showActive);
		}

		if (this.certificateActiveContainer) {
			this.certificateActiveContainer.style.display = activeState;
		}

		if (showActive) {
			const closeBtn = this.filterWrapper?.closest('.catalog-head')?.querySelector('.js-filter-close');
			closeBtn ? closeBtn.click() : (this.filterWrapper && (this.filterWrapper.style.display = 'none'));
		}
	}

	_getPinToken(partnerForm) {
		document.body.classList.add('overflow');
		const overlay = document.querySelector('.certificate-popup-overlay');
		if (overlay) overlay.style.display = 'block';
		this._openCertificatePopup('#pop_pin_insert', '#form-pin-insert');

		const pinForm = document.querySelector('#certificate_pin_insert');
		const handlePinSubmit = (e) => {
			e.preventDefault();
			const form = e.currentTarget;
			const input = form.querySelector('#form-pin-insert');
			const pin = input.value;
			const submitBtn = form.querySelector('[type="submit"]');

			submitBtn.disabled = true;
			this._clearInputError(input);

			if (!/^[0-9]{4}$/.test(pin)) {
				this._setInputError(input, 'PIN-код має містити 4 цифри');
				submitBtn.disabled = false;
				this._focusInput(input);
				return;
			}

			const url = this.certificateData.apiDomain + this.certificateData.methods.getPinToken;
			fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': this._getToken()
				},
				body: JSON.stringify({
					phone: window.CertificateCustomerData.phone,
					code: pin
				})
			})
				.then(r => r.ok ? r.json() : Promise.reject(r))
				.then(data => {
					document.body.classList.remove('overflow');
					const pinInsert = document.querySelector('#pop_pin_insert');
					if (pinInsert) pinInsert.style.display = 'none';
					if (overlay) overlay.style.display = 'none';
					input.value = '';
					submitBtn.disabled = false;
					pinForm.removeEventListener('submit', handlePinSubmit);
					this._createCertificate(partnerForm, data.token);
				})
				.catch(err => {
					if (err.status === 422 || err.status === 401 || err.status === 500) {
						this._setInputError(input, 'Не вірний код');
						this._focusInput(input);
					}
					submitBtn.disabled = false;
				});
		};

		pinForm?.addEventListener('submit', handlePinSubmit);
	}

	_createCertificate(form, pinToken) {
		if (!pinToken) {
			form.closest('.partner-card__form').style.display = 'block';
			form.closest('.partner-card__form').nextElementSibling.style.display = 'none';
			form.querySelector('[type="submit"]').disabled = false;
			return;
		}

		const data = {
			phone: form.dataset.customerPhone,
			partner_id: form.dataset.partnerId,
			amount: form.querySelector('[name="amount"]').value,
			pin_token: pinToken
		};

		if (form.dataset.mobileOperator === 'true') {
			data.phone_topup = form.dataset.customerPhone;
		}

		const url = this.certificateData.apiDomain + this.certificateData.methods.createCertificate;

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': this._getToken()
			},
			body: JSON.stringify(data)
		})
			.then(async r => {
				const res = await r.json();
				if (!r.ok) throw res;
				return res;
			})
			.then(() => {
				const partnerCard = form.closest('.partner-card');
				partnerCard.querySelector('.partner-card__form-loading').style.display = 'none';
				this._showCertificateResult(partnerCard.querySelector('.partner-card__form-success'));

				const activeLimit = partnerCard.querySelector('.limit-value.active');
				if (activeLimit) {
					let limit = parseInt(activeLimit.dataset.limit, 10);
					if (limit > 0) {
						limit--;
						activeLimit.dataset.limit = limit;
						activeLimit.firstChild.textContent = `${limit} шт `;
						if (limit === 0) {
							setTimeout(() => {
								activeLimit.classList.remove('active');
								activeLimit.classList.add('sould', 'sould-full');
								form.style.display = 'none';
							}, 8000);
						}
					}
				}

				if (partnerCard.classList.contains('wrapper-mobile-operator')) {
					document.querySelectorAll('.partner-card.wrapper-mobile-operator').forEach(el => el.style.display = 'none');
					partnerCard.style.display = 'block';
				}

				setTimeout(() => {
					partnerCard.querySelector('.partner-card__form-success').style.display = 'none';
					partnerCard.querySelector('.partner-card__form').style.display = 'block';

					if (partnerCard.classList.contains('wrapper-mobile-operator')) {
						const lv = partnerCard.querySelector('.limit-value');
						const limit = parseFloat(lv.dataset.amountLimit);
						const spent = parseFloat(lv.dataset.spent);
						const newValue = limit - spent;
						if (newValue > 1) {
							lv.innerHTML = `${newValue} грн`;
							const input = form.querySelector('input');
							input.value = '';
							input.max = newValue;
						} else {
							partnerCard.style.display = 'none';
						}
					}
				}, 8000);

				form.querySelector('.partner-card__form-send').disabled = false;
			})
			.catch(err => {
				const partnerCard = form.closest('.partner-card');
				const successBlock = partnerCard.querySelector('.partner-card__form-success');
				const loadingBlock = partnerCard.querySelector('.partner-card__form-loading');

				if (loadingBlock) loadingBlock.style.display = 'none';

				if (successBlock) {
					const errorMsg = err?.errors?.amount?.[0];
					if (errorMsg) {
						successBlock.dataset.originalHtml = successBlock.innerHTML;
						successBlock.innerHTML = `
							<p>${errorMsg}</p>
							<button class="btn btn--ghost certificate-btn js-error-close">
								Зрозуміло
							</button>
						`;
					}
					this._showCertificateResult(successBlock, true);
				}

				setTimeout(() => {
					if (successBlock && successBlock.style.display === 'block') {
						successBlock.style.display = 'none';
						if (successBlock.dataset.originalHtml) {
							successBlock.innerHTML = successBlock.dataset.originalHtml;
							delete successBlock.dataset.originalHtml;
						}
						form.closest('.partner-card__form').style.display = 'block';
						form.querySelector('.partner-card__form-send').disabled = false;
					}
				}, 120000);
			});
	}

	_installPin(evt) {
		evt.preventDefault();
		const form = evt.currentTarget;
		const pinInput = form.querySelector('input');
		const pin = pinInput.value;

		const submitBtn = form.querySelector('[type="submit"]');
		submitBtn.disabled = true;

		this._clearInputError(pinInput);

		if (!/^[0-9]{4}$/.test(pin)) {
			this._setInputError(pinInput, 'PIN-код має містити 4 цифри');
			submitBtn.disabled = false;
			this._focusInput(pinInput);
			return;
		}

		const url = this.certificateData.apiDomain + this.certificateData.methods.installPin;

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': this._getToken()
			},
			body: JSON.stringify({
				phone: window.CertificateCustomerData.phone,
				code: pin
			})
		})
			.then(async r => {
				const data = await r.json();
				if (!r.ok) throw { status: r.status, data };
				return data;
			})
			.then(data => {
				sessionStorage.setItem('temp_pin', pin);

				const popItem = form.closest('.pop-item');
				if (popItem) popItem.style.display = 'none';

				document.body.classList.add('overflow');
				const overlay = document.querySelector('.certificate-popup-overlay');
				if (overlay) overlay.style.display = 'block';

				setTimeout(() => {
					const popupId = data.need_verification ? '#pop_pin_sms' : '#pop_pin_success';
					this._openCertificatePopup(popupId, data.need_verification ? '#form-sms' : null);
					if (data.need_verification) {
						if (!this.cooldown) this._setSmsTimer();
						if (this.resendBtn) this.resendBtn.disabled = true;
						this.cooldown?.start(60);
					}
				}, 500);

				pinInput.value = '';
				submitBtn.disabled = false;
			})
			.catch(err => {
				submitBtn.disabled = false;
				if (err.status === 422) {
					this._setInputError(pinInput, 'Невірний PIN-код');
					this._focusInput(pinInput);
				}
				if (err.status === 429) {
					this._setInputError(pinInput, 'Досягнуто ліміт зміни PIN-коду');
					this._focusInput(pinInput);
				}
			});
	}

	_setSmsTimer() {
		const COOLDOWN_SEC = 60;
		this.cooldown = createCooldownWithLock({
			seconds: COOLDOWN_SEC,
			onTick: (secLeft) => {
				if (!this.timerEl) return;
				this.timerEl.textContent = `${Math.max(0, secLeft | 0)}`;
			},
			onEnable: () => {
				if (this.resendBtn) this.resendBtn.disabled = false;
			},
		});
	}

	_sendSms(evt) {
		evt.preventDefault();

		const form = evt.currentTarget;
		const input = form.querySelector('input');
		const submitBtn = form.querySelector('[type="submit"]');

		submitBtn.disabled = true;
		input.closest('.input')?.classList.remove('input--error');

		const code = input.value;

		if (!/^[A-Za-z0-9!$%@?_*.]{6}$/.test(code)) {
			input.closest('.input')?.classList.add('input--error');
			submitBtn.disabled = false;
			return;
		}

		const url = this.certificateData.apiDomain + this.certificateData.methods.sendSms;

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': this._getToken()
			},
			body: JSON.stringify({
				phone: window.CertificateCustomerData.phone,
				code
			})
		})
			.then(async r => {
				if (!r.ok) throw r;
				return await r.json();
			})
			.then(() => {
				sessionStorage.removeItem('temp_pin');
				this.cooldown?.stop();
				const smsPop = document.querySelector('#pop_pin_sms');
				if (smsPop) smsPop.style.display = 'none';
				setTimeout(() => {
					const successPopup = document.querySelector('#pop_pin_success');
					if (successPopup) successPopup.style.display = 'block';
					this.createPinBtn.hidden = true;
					this.setedPinBlock.hidden = false;
					this.setedPinBlock.style.display = 'flex';
				}, 500);
				submitBtn.disabled = false;
				input.value = '';
			})
			.catch(() => {
				input.closest('.input')?.classList.add('input--error');
				submitBtn.disabled = false;
			});
	}

	_resendSms(btn) {
		const url = this.certificateData.apiDomain + this.certificateData.methods.installPin;

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': this._getToken()
			},
			body: JSON.stringify({
				phone: window.CertificateCustomerData.phone,
				code: sessionStorage.getItem('temp_pin')
			})
		})
			.then(r => {
				if (!r.ok) throw r;
				if (this.cooldown) {
					btn.disabled = true;
					this.cooldown.start(60);
				} else {
					btn.disabled = false;
				}
			})
			.catch(() => {
				btn.disabled = false;
				btn.insertAdjacentHTML('beforebegin', `<div class="help-block">Помилка повторної відправки</div>`);
			});
	}

	_getMessage(categoryId = false) {
		let url = this.certificateData.apiDomain +
			this.certificateData.methods.getMessage +
			'/' + window.CertificateCustomerData.phone;

		if (Number.isInteger(parseInt(categoryId))) {
			url += '/' + categoryId;
		}

		fetch(url, { headers: { Authorization: this._getToken() } })
			.then(r => r.json())
			.then(data => {
				if (!data?.top_message) return;

				const target = categoryId === 'main' ? this.certificateContainer : this.partnerContainer;
				const msgEl = target?.querySelector('.certificate-message');
				if (msgEl) {
					msgEl.innerHTML = data.top_message;
					msgEl.style.display = 'block';
				}
			});
	}

	_getToken() {
		return `Bearer ${this.token}`;
	}

	_btnEvents() {
		document.addEventListener('keydown', this._handlePartnerInfoKeydown);
		document.addEventListener('keydown', this._handleCertificatePopupKeydown);

		document.addEventListener('click', e => {

			if (e.target.closest('.js-create-pin')) {
				document.body.classList.add('overflow');
				const overlay = document.querySelector('.certificate-popup-overlay');
				if (overlay) overlay.style.display = 'block';
				this._openCertificatePopup('#pop_pin', '#form-pin');
			}

			const smsResendBtn = e.target.closest('.js-sms-resend');
			if (smsResendBtn) {
				smsResendBtn.disabled = true;
				this._resendSms(smsResendBtn);
			}

			if (e.target.closest('.js-pop-close') || e.target.closest('.js-error-close')) {
				const popItem = e.target.closest('.pop-item');
				if (popItem) {
					popItem.style.display = 'none';

					if (popItem.id === 'pop_pin_sms') {
						this.cooldown?.stop();
					}

					if (popItem.id === 'pop_pin_insert') {
						const loading = document.querySelectorAll('.partner-card__form-loading');
						const forms = document.querySelectorAll('.partner-card__form');
						loading.forEach(el => el.style.display = 'none');
						forms.forEach(el => {
							el.style.display = 'block';
							const input = el.querySelector('input[name="amount"]');
							if (input) input.value = '';
							const sendBtn = el.querySelector('.partner-card__form-send');
							if (sendBtn) sendBtn.disabled = false;
						});
					}
				} else if (e.target.closest('.js-error-close')) {
					const partnerCard = e.target.closest('.partner-card');
					if (partnerCard) {
						const successBlock = partnerCard.querySelector('.partner-card__form-success');
						successBlock.style.display = 'none';
						if (successBlock.dataset.originalHtml) {
							successBlock.innerHTML = successBlock.dataset.originalHtml;
							delete successBlock.dataset.originalHtml;
						}
						partnerCard.querySelector('.partner-card__form').style.display = 'block';
						const sendBtn = partnerCard.querySelector('.partner-card__form-send');
						if (sendBtn) sendBtn.disabled = false;
					}
				}
				const overlay = document.querySelector('.certificate-popup-overlay');
				if (overlay) overlay.style.display = 'none';
				document.body.classList.remove('overflow');
			}

			if (e.target.closest('.js-back-to-category')) {
				this._toggleActiveCertView(false);
				const top = this.certificateContainer.offsetTop - 320;
				window.scrollTo({ top: top, behavior: 'smooth' });
			}

			if (e.target.closest('.partner-card__info-btn')) {
				this._openPartnerInfo(e.target.closest('.partner-card__info-btn'));
			}

			if (e.target.closest('.partner-card__info .close')) {
				this._closePartnerInfo(e.target.closest('.partner-card__info'));
			}

			if (e.target.closest('.js-recovery-pin')) {
				const popPinInsert = e.target.closest('#pop_pin_insert');
				if (popPinInsert) {
					popPinInsert.style.display = 'none';
					popPinInsert.classList.remove('pop-blocking');

					const loading = document.querySelectorAll('.partner-card__form-loading');
					const forms = document.querySelectorAll('.partner-card__form');
					loading.forEach(el => el.style.display = 'none');
					forms.forEach(el => {
						el.style.display = 'block';
						const input = el.querySelector('input[name="amount"]');
						if (input) input.value = '';
						const sendBtn = el.querySelector('.partner-card__form-send');
						if (sendBtn) sendBtn.disabled = false;
					});
				}
				document.body.classList.add('overflow');
				const overlay = document.querySelector('.certificate-popup-overlay');
				if (overlay) {
					overlay.style.display = 'block';
					overlay.classList.add('pop-blocking');
				}
				setTimeout(() => {
					this._openCertificatePopup('#pop_pin_recovery', '#form-pin-recovery');
				}, 500);
			}

			/* ORDER CERTIFICATE */
			const sendBtn = e.target.closest('.partner-card__form-send');
			if (sendBtn && !sendBtn.href) {
				e.preventDefault();
				const form = sendBtn.closest('form');
				if (!form) return;

				sendBtn.disabled = true;
				const amountInput = form.querySelector('[name="amount"]');
				const amountVal = amountInput ? amountInput.value : '';

				if (form.dataset.lock === 'true' || sendBtn.closest('.partner-card__form').classList.contains('unverified')) {
					sendBtn.disabled = false;
					return;
				}

				if (amountVal !== '') {
					const isInput = amountInput.tagName === 'INPUT';
					if (isInput && this.certificateMinLimit > 0 && parseInt(amountVal, 10) < this.certificateMinLimit) {
						amountInput.closest('.input')?.classList.add('input--error');
						sendBtn.disabled = false;
					} else {
						const partnerCardForm = sendBtn.closest('.partner-card__form');
						if (partnerCardForm) {
							partnerCardForm.style.display = 'none';
							partnerCardForm.nextElementSibling.style.display = 'block';
						}
						this._getPinToken(form);
					}
				} else {
					amountInput?.closest('.input')?.classList.add('input--error');
					sendBtn.disabled = false;
				}
			}

			if (e.target.closest('.certificate-btn:not(.js-create-pin)')) {
				this._getActiveCertificate();
			}
		});

		document.addEventListener('change', e => {
			if (e.target.matches('#form-pin, #form-pin-recovery, #form-pin-insert, [name="amount"]')) {
				this._clearInputError(e.target);
			}
		});
	}

	_initCatalogXpFilters() {
		const filtersWrapper = document.querySelector('.catalog-main__filters--xp');
		const selectEl = document.querySelector('#select-product-xp');
		const certificateBlock = document.querySelector('.catalog__xp-group--certificates');
		const productsBlock = document.querySelector('.catalog__xp-group--products');

		if (!filtersWrapper || !selectEl) return;

		const filterButtons = filtersWrapper.querySelectorAll('.catalog-main__filters-item');
		// tom-select before init or not init
		let ts = null;


		if (selectEl.classList.contains('tomselected')) {
			ts = selectEl.tomselect;
		}

		const updateBlocks = (value) => {
			if (value === 'all-xp') {
				certificateBlock && (certificateBlock.style.display = 'block');
				productsBlock && (productsBlock.style.display = 'block');
			} else if (value === 'certificate') {
				certificateBlock && (certificateBlock.style.display = 'block');
				productsBlock && (productsBlock.style.display = 'none');
			} else if (value === 'all-xp-product') {
				certificateBlock && (certificateBlock.style.display = 'none');
				productsBlock && (productsBlock.style.display = 'block');
			}
		};

		const setActiveButton = (value) => {
			filterButtons.forEach(btn => {
				if (btn.dataset.value === value) {
					btn.classList.add('is-active-filter');
				} else {
					btn.classList.remove('is-active-filter');
				}
			});
		};

		const initialValue = ts ? ts.getValue() : selectEl.value;
		if (initialValue) {
			setActiveButton(initialValue);
			updateBlocks(initialValue);
		}

		filterButtons.forEach(btn => {
			btn.addEventListener('click', () => {
				const value = btn.dataset.value;
				setActiveButton(value);
				if (ts) {
					ts.setValue(value, true);
				} else {
					selectEl.value = value;
				}
				updateBlocks(value);
			});
		});

		if (ts) {
			ts.on('change', (value) => {
				setActiveButton(value);
				updateBlocks(value);
			});
		} else {
			selectEl.addEventListener('change', (e) => {
				const value = e.target.value;
				setActiveButton(value);
				updateBlocks(value);
			});
		}
	}

}
